import { render } from "./FormSection.vue?vue&type=template&id=48e651fe&scoped=true"
import script from "./FormSection.vue?vue&type=script&lang=js"
export * from "./FormSection.vue?vue&type=script&lang=js"

import "./FormSection.vue?vue&type=style&index=0&id=48e651fe&scoped=true&lang=css"

import exportComponent from "/Users/rs/Development/alisops/aclu-or-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e651fe"]])

export default __exports__